import store from '../../../index';

export default {
    namespaced: true,
    state: {
        currentRedirection: {},
        defaultRedirection: {
            url: ''
        }
    },

    getters: {
        defaultRedirection: (state) => {
            return state.defaultRedirection;
        }
    },

    mutations: {
        CLEAN_REDIRECTION: (state) => {
            state.currentRedirection = store.state.actions.action.data;
        },
        SET_DATA: (state, data) => {
            state.currentRedirection = Object.assign({}, state.currentRedirection, data);
        },
        CLEAN_CURRENT_DATA: (state) => {
            state.currentRedirection = {};
        }
    },

    actions: {
        redirectionUpdate: function (localStore, data) {
            return new Promise(function (resolve, reject) {
                let value = { ...localStore.state.currentRedirection };
                store.dispatch('actions/updateActionData', value).then(() => {
                    resolve();
                }).catch((err) => {
                    reject(err);
                });
            });
        },
        cleanRedirection: function (localStore) {
            localStore.commit('CLEAN_REDIRECTION');
        }
    }
};
